import { render } from "./TransfersPage.vue?vue&type=template&id=40fbe613&scoped=true"
import script from "./TransfersPage.vue?vue&type=script&lang=js"
export * from "./TransfersPage.vue?vue&type=script&lang=js"

import "./TransfersPage.vue?vue&type=style&index=0&id=40fbe613&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fbe613"]])

export default __exports__